import xmlIcon from "../../../assets/xml.png";
import xmlsIcon from "../../../assets/xmls.png";
import pdfIcon from "../../../assets/pdf-file.png";
import documentIcon from "../../../assets/document-text.svg";
import pdfoIcon from "../../../assets/pdfo-file.png";
import classes from "./ReturnDoc.module.scss";
import { Checkbox } from "@mui/material";

const ImageDoc = ({doc, onDocClicked,id, checked=false}) => {
    const getImageForDoc = (doc) =>{
        switch(doc){
            case "PDF":
                return <img src={pdfIcon} alt="profile" width="70" height="90"/>
            case "PDFO":
                return <img src={pdfoIcon} alt="profile" width="70" height="90"/>
            case "XMLS":
                return <img src={xmlsIcon} alt="profile" width="70" height="70" style={{marginTop:"10px"}}/>
            case "XMLP":
                return <img src={xmlIcon} alt="profile" width="70" height="70" style={{marginTop:"10px"}}/>
            default:
                return <img src={documentIcon} alt="profile" width="70" height="90"/>
        }
    }
    const onClick = (e) => {
        if(onDocClicked)
            onDocClicked(doc, !checked)
    }
    const handleChange = (e) => {

    }
    return(
        <div id={id} className={classes["card"]} style={{minWidth:"90px",width:"90px", height:"100px", textAlign:"center"}} onClick={onClick}>
                <div style={{height:"1px", textAlign:"right"}}>
                    <Checkbox size="small" 
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'controlled' }}/>
                </div>
                {getImageForDoc(doc)}
        </div>
    )
}

export default ImageDoc;